/**
 * Fetch browser safe config from the server
 * @module services/config
 */
import { fromJS } from 'immutable'
import _get from 'lodash/get'
import request from '../request'
import { createAuthorization } from '../auth'

export const storeKey = 'csParamsList'

/**
 * Get a list of content search params
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 * @param {number} options.offset The query offset
 * @param {number} options.limit The query limit
 */
export async function getCSParamsList (options = {}) {
  const {
    server, auth, offset, limit, contentType, searchColumn,
  } = options
  const res = await request
    .get(`${server}/v1/content-search-params/list`)
    .query({
      offset, limit, contentType, searchColumn,
    })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}

/**
 * Update (or create if no id present) a content search param, allows partial update
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 * @param {number} options.id The content search param id
 * @param {Map} options.data The POST request body
 */
export async function upsertCSParam (options = {}) {
  const { server, auth, data } = options
  // console.log(data.toJS())
  const res = await request
    .post(`${server}/v1/content-search-params`)
    .send(data.toJS())
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}

/**
 * Remove a content search parameter
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 * @param {number} id The id of the parameter to remove
 */
export async function deleteCSParam ({ auth, server, id }) {
  const res = await request
    .delete(`${server}/v1/content-search-params/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

/**
 * Call brooklyn to reindex content search table
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 */
export async function reindex ({ auth, server }) {
  const res = await request
    .get(`${server}/v1/content-search-reindex`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}
